import defaultAttributes from '../defaultAttributes';

const Diff = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M12 3v14' }],
    ['path', { d: 'M5 10h14' }],
    ['path', { d: 'M5 21h14' }],
  ],
];

export default Diff;
